import React from 'react';
import { FaWindowClose } from 'react-icons/fa';

const ModalBase = ({ isOpen, onClose, title, className, children }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-[100] flex items-center justify-center">
      <div className={`${className ? className : 'bg-gray-300 text-black' } max-h-[90vh] min-w-[400px] mx-2 p-4 rounded shadow-lg float shadow-white`}>
        <div className='flex items-center justify-between'>
        <h2 className="!text-4xl font-bold special-font mb-2">{title}</h2>
        <button onClick={onClose}><FaWindowClose className='text-2xl hover:animate-spin' /></button>
        </div>
        <div className='max-h-[80vh] overflow-y-auto'>
          {children}</div>
        {/* <button className="mt-4 p-2 z-[100] bg-red-500 text-white rounded" >
          Cerrar
        </button> */}
      </div>

      
    </div>
  );
};

export default ModalBase;